import { render } from "./UiInputMasked.vue?vue&type=template&id=811e36d2&scoped=true&ts=true"
import script from "./UiInputMasked.vue?vue&type=script&lang=ts"
export * from "./UiInputMasked.vue?vue&type=script&lang=ts"

import "./UiInputMasked.vue?vue&type=style&index=0&id=811e36d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811e36d2"]])

export default __exports__